module.exports = __webpack_public_path__ + "img/roadmap-impostor-3.9f64889d.png";